<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
          prop="resultCategory"
          label="测评类">
          <a-input placeholder="请输入测评类" v-model="model.resultCategory" />
        </a-form-model-item>
        <a-form-model-item
          prop="name"
          label="测评名称">
          <a-input placeholder="请输入测评名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item 
          prop="periodItemId"
          label="周期">
          <a-select v-model="model.periodItemId" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in periodItemList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
            prop="formulaId"
          label="公式">
          <a-select v-model="model.formulaId" placeholder="请选择" showSearch :filterOption="filterOptionTip">
            <a-select-option :value="item.id" v-for="item in formulaList" :key="item.id">
              <a-tooltip :title="item.formDes" placement="right">
                {{item.formName}}-{{item.formItemName}}
              </a-tooltip>              
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="personAvg"
          label="人群平均分">
          <a-input placeholder="请输入人群平均分" v-model="model.personAvg" />
        </a-form-model-item>
        <a-form-model-item
          prop="maxNum"
          label="测评最大值">
          <a-input-number placeholder="请输入测评最大值" style="width: 200px" :min="0" v-model="model.maxNum" />
        </a-form-model-item>
        <a-form-model-item
          label="是否显示">
          <a-radio-group v-model="model.view" >
            <a-radio-button value="0">
              否
            </a-radio-button>
            <a-radio-button value="1">
              是
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="备注">
          <a-textarea :rows="5" v-model="model.description" placeholder="请输入备注"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: "ProjectResultConfigItemModal",
    components: { ATextarea },
    props:{
      resultList:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title:"操作",
        visible: false,
        model: {},
        rules:{
          resultCategory:[baseRules.required],
          formulaId:[baseRules.required],
          personAvg:[baseRules.required],
          name:[baseRules.required],
          config:[baseRules.required],
          periodItemId:[baseRules.required],
          maxNum:[baseRules.required],
        },
        confirmLoading: false,
        formulaList:[],
        periodItemList:[],
        url: {
          add: "/project/projectResultConfigItem/add",
          edit: "/project/projectResultConfigItem/edit",
        },
      }
    },
    created () {
      getAction('/project/projectFormula/listAll',{projectId:this.projectId,type:'1'}).then(res=>{
          if(res.success){
            this.formulaList = res.result
          }
      })
      getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
        if(res.success){
          this.periodItemList=res.result
        }
      })
    },
    methods: {
      test(){
      },
      add () {
        this.edit({
          projectId:this.projectId,
          view:'1',
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      filterOptionTip(input, option) {
        return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style lang="less" scoped>

</style>